import { createFileRoute, redirect } from "@tanstack/react-router";
import { firstAdminPath, loadAdminNavOrder } from "@/hooks/use-admin-nav-order";

export const Route = createFileRoute("/_authenticated/admin/")({
  beforeLoad: async ({ context }) => {
    const user = (context as { user?: { id?: string; role?: string | null } }).user;
    // Land on the first page of this admin's own list (their custom order, or the default one).
    throw redirect({ to: firstAdminPath(user?.role, await loadAdminNavOrder(user?.id)) as "/admin/users" });
  },
});
